export default{
    firebaseFunctionUrl:"https://us-central1-hivedb-cdbf7.cloudfunctions.net/"
}